import { useState } from 'react';

export function useDisclosure(initialValue: boolean = false) {
    const [opened, setOpened] = useState(initialValue);

    const actions = {
        open: () => setOpened(true),
        close: () => setOpened(false),
        toggle: () => setOpened(!opened),
    }

    return [opened, actions] as const;
}
